/** Parses a URL, or returns `undefined` if `value` is missing or malformed. */
export const urlOf = (value?: string | null) => {
  if (!value) return undefined;
  // jsdom, which the component tests run in, has no URL.canParse.
  try {
    return new URL(value);
  } catch {
    return undefined;
  }
};
